import { render, staticRenderFns } from "./DistributorForm.vue?vue&type=template&id=be712b74&scoped=true"
import script from "./DistributorForm.vue?vue&type=script&lang=js"
export * from "./DistributorForm.vue?vue&type=script&lang=js"
import style0 from "./DistributorForm.vue?vue&type=style&index=0&id=be712b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be712b74",
  null
  
)

export default component.exports